import { useContext } from 'react';
import { ReactConsentContext } from './ConsentContextProvider';
import McpFlowParametersSwitch from '../MainContent/MCP-optional-sites/McpFlowParametersSwitch';
import A2AFlowParameters from '../MainContent/A2A/A2AFlowParameters';
import TwgFlowParameters from '../MainContent/TWG/TwgFlowParameters';

// Additional fields to be included in the POST /resume form action
const FlowParameters = () => {
  const context = useContext(ReactConsentContext);

  if (!context) {
    throw new Error(
      'FlowParameters must be used within ConsentContextProvider',
    );
  }

  const { token, selectedWorkspace } = context;

  return (
    <>
      <input type="hidden" name="context" value={token.raw} />
      {token.serviceType !== 'MCP' && selectedWorkspace && (
        <input
          type="hidden"
          name="selectedWorkspace"
          value={selectedWorkspace}
        />
      )}
      {token.serviceType === 'MCP' && <McpFlowParametersSwitch />}
      {token.serviceType === 'A2A' && <A2AFlowParameters />}
      {token.serviceType === 'TWG' && <TwgFlowParameters />}
    </>
  );
};

export default FlowParameters;
